module.exports = __webpack_public_path__ + "static/media/event.3e828a78.webp";